module.exports = __webpack_public_path__ + "img/solution-data-logo5.53c96141.png";